import { ref, uploadBytesResumable, getDownloadURL, listAll, deleteObject } from 'firebase/storage';
import { storage } from '../firebase';

const uploadFile = (projectId, projectName, file, path, onProgress, fileName = file.name, customMetadata = {}, skipDownloadURL = false) => {
	return new Promise((resolve, reject) => {
		const folderRef = ref(storage, `${projectId}/${path}/${fileName}`);
		const uploadTask = uploadBytesResumable(folderRef, file, { customMetadata });

		uploadTask.on(
			'state_changed',
			(snapshot) => {
				const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				onProgress(progress);
			},
			(error) => {
				reject(error);
			},
			() => {
				if (skipDownloadURL) {
					resolve(null);
					return;
				}
				getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
					resolve(downloadURL);
				}).catch((error) => {
					reject(error);
				});
			}
		);
	});
};

const deleteProjectStorage = async (directoryPath) => {
	const directoryRef = ref(storage, directoryPath);

	try {
		const list = await listAll(directoryRef);
		const fileDeletions = list.items.map((itemRef) => deleteObject(itemRef));
		const subdirDeletions = list.prefixes.map((subdirRef) => deleteProjectStorage(subdirRef.fullPath));

		await Promise.all([...fileDeletions, ...subdirDeletions]);
	} catch (error) {
		console.error('Error deleting directory: ', error);
		throw error;
	}
};

export { uploadFile, deleteProjectStorage };
